/**
 * @returns {Object|null}
 */
export const getAuthUser = () => {
  const user = localStorage.getItem("authUser");
  try {
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error("Error parsing authUser from localStorage", error);
    return null;
  }
};

/**
 * @returns {number|null}
 */
export const getUserRole = () => {
  const role = localStorage.getItem("userRole");
  return role ? parseInt(role, 10) : null;
};
/**
 * @returns {number|null}
 */
export const getCountryId = () => {
  const userData = localStorage.getItem("authUser");
  try {
    const authUser = userData ? JSON.parse(userData) : null;
    const location = authUser?.user?.location;
    return location ? parseInt(location, 10) : null;
  } catch (error) {
    console.error("Error parsing authUser for location", error);
    return null;
  }
};

/**
 * @returns {string|null}
 */
export const getToken = () => {
  return localStorage.getItem("token");
};
